module.exports = "/images/vendor/desiigner-svg/svg/ui/chevron-up.svg?552efaacade624203e8762462b2f7687";